import React from "react";
import { Link } from "react-router-dom";
import "./WeFPO.css";

export default function WeFPO() {
  return (
    <section className="who-section">
      <div className="who-container">

        {/* TITLE */}
        <h2 className="who-title">Financial Process Outsourcing (FPO)</h2>

        {/* DESCRIPTION */}
        <p className="who-desc">
         The Densat Finance Methodology / FPO The practice of outsourcing brings together two of the finest aspects of business
        </p>

        {/* BREADCRUMB */}
        <p className="who-breadcrumb">
          <Link to="/" className="who-breadcrumb-link">Home</Link>
          <span className="who-breadcrumb-separator">–</span>
          <Link
            to="/fpo"
            className="who-breadcrumb-link who-breadcrumb-current"
          >
            FPO
          </Link>
        </p>

      </div>
    </section>
  );
}
